import { useI18n } from '@locales/client';
import { NotFound, Wrapper } from '@/widgets/game-sections/ui/styles';
import { BodyTextRegularPrimary } from '@/shared/ui/typography';

export function MobileSearchNotFound() {
  const t = useI18n();
  return (
    <Wrapper>
      <NotFound>
        <BodyTextRegularPrimary color="#AFAFAF">
          {t('common.not_found')}
        </BodyTextRegularPrimary>
      </NotFound>
    </Wrapper>
  );
}